/* dl-fuzzy.js — oprava překlepů ve vyhledávání (2026-09-03)

   PROBLÉM
   Shopify Predictive Search hledá na přesnou shodu. Zákazník, který zná lampu
   jen ze slyšení, napíše „mykonos“ místo „Miconos“ a dostane prázdno. Totéž
   „kimera“ / Chimera, „agregato“ / Aggregato, „dioskuri“ / Dioscuri.

   ŘEŠENÍ, KTERÉ NESAHÁ NA dl-search.js
   Tenhle soubor obaluje window.fetch a chytá JEN volání na /search/suggest.
   Když odpověď nevrátí ani jeden produkt, zkusí dotaz opravit podle slovníku
   slov z katalogu a zeptá se API znovu. Teprve když i opravený dotaz vrátí
   nulu, propustí původní prázdnou odpověď. dl-search.js o tom neví a nemusí
   se měnit — což je u 20 kB souboru, který drží celý našeptávač, záměr.
   Rollback = smazat řádek se skriptem ze snippets/dl-search-config.liquid.

   SLOŽENÍ SLOVA (fold)
   Klíčem není slovo, ale jeho složený tvar, do kterého spadnou všechny běžné
   způsoby zápisu téhož:
       diakritika pryč · ph->f · th->t · ch->k · w->v · q->k · x->ks
       c->k · y->i · zdvojené písmeno -> jedno
   „mykonos“ i „Miconos“ jsou po složení shodně „mikonos“ — trefa bez počítání
   vzdálenosti. Slova s „ch“ leží ve slovníku pod oběma klíči (ch->k i ch->h),
   protože italské značky se čtou s /k/ (Chimera = kimera), ale česká slova
   s /ch/. Fold TADY a fold v /root/work/fuzzy/build_index.py musí zůstat
   shodné — jinak se klíče rozejdou a slovník přestane fungovat.

   KDYŽ SLOŽENÍ NESTAČÍ
   1) rozepsané slovo: klíč je předponou klíče ze slovníku („mykon“ -> Miconos)
   2) překlep: Damerau-Levenshtein nad složeným tvarem, práh podle délky
      (do 7 znaků 1, do 10 znaků 2, výš 3). První písmeno musí sedět — jinak
      by krátká slova skákala mezi nesouvisejícími značkami.
   Slovník je seřazený podle četnosti v katalogu, takže při shodné vzdálenosti
   vyhraje běžnější slovo.

   MĚŘENO na 1 663 uměle poškozených názvech z katalogu:
   vypadlé písmeno 88 %, zdvojení 99 %, prohození 97 %, i->y 100 %,
   c<->k 100 %, jiná samohláska 95 %. Jedna oprava trvá 0,10 ms.

   SLOVNÍK  assets/dl-fuzzy-slova.txt — 592 slov z názvů AKTIVNÍCH produktů
   a značek, jedno na řádek, v pořadí četnosti v katalogu (na tom pořadí stojí
   rozhodování při remíze). Jen slova, která se aspoň jednou píšou s velkým
   písmenem; bez českých slov (ta Shopify najde i bez háčků sám — ověřeno,
   dotaz „zavesna“ vrací 179 výsledků) a bez kódů barev kabelů typu RM04,
   které nikdo nekomolí a jen kradly shody. 3,9 kB, stahuje se až v nečinnosti
   prohlížeče, ne při načtení stránky. Přegenerovat po větší změně katalogu:
   python3 /root/work/fuzzy/build_index.py
*/
(function () {
  var CFG = window.DL_SEARCH || {};
  var IDX_URL = CFG.fuzzyWords || '';
  if (!IDX_URL || !window.fetch) return;

  var ROWS = null, asked = false;
  var origFetch = window.fetch.bind(window);

  /* Slovník je prostý seznam slov, jedno na řádek, v pořadí četnosti v katalogu.
     Klíče se dopočítají tady — soubor tak nese jen to, co se nedá odvodit. */
  function loadIndex() {
    if (asked) return;
    asked = true;
    origFetch(IDX_URL, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        var words = String(t).split('\n'), rows = [], seen = {}, i, k, ks;
        for (i = 0; i < words.length; i++) {
          if (!words[i]) continue;
          ks = folds(words[i]);
          for (k = 0; k < ks.length; k++) {
            if (!seen[ks[k]]) { seen[ks[k]] = 1; rows.push([ks[k], words[i]]); }
          }
        }
        if (rows.length) ROWS = rows;
      })
      .catch(function () {});
  }
  if (window.requestIdleCallback) requestIdleCallback(loadIndex, { timeout: 4000 });
  else setTimeout(loadIndex, 2500);

  /* --- složení -------------------------------------------------------- */
  var DIA = { 'á':'a','č':'c','ď':'d','é':'e','ě':'e','í':'i','ň':'n','ó':'o','ř':'r',
              'š':'s','ť':'t','ú':'u','ů':'u','ý':'y','ž':'z','à':'a','è':'e','ì':'i',
              'ò':'o','ù':'u','ä':'a','ö':'o','ü':'u','ß':'s','ñ':'n','ç':'c','å':'a',
              'ø':'o','æ':'a','œ':'o','ã':'a','õ':'o','â':'a','ê':'e','î':'i','ô':'o','û':'u' };

  function strip(s) {
    s = String(s).toLowerCase().replace(/[^\x00-\x7f]/g, function (c) { return DIA[c] || c; });
    if (s.normalize) s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    return s;
  }
  function core(s, chAs) {
    s = s.replace(/ph/g, 'f').replace(/th/g, 't')
         .replace(/sch/g, 's').replace(/sh/g, 's')
         .replace(/ch/g, chAs)
         .replace(/qu/g, 'k').replace(/q/g, 'k')
         .replace(/w/g, 'v').replace(/x/g, 'ks')
         .replace(/c/g, 'k').replace(/y/g, 'i')
         .replace(/[^a-z0-9]/g, '');
    return s.replace(/(.)\1+/g, '$1');
  }
  function folds(w) {
    var s = strip(w), out = [], a = core(s, 'k');
    if (a) out.push(a);
    if (s.indexOf('ch') > -1) { var b = core(s, 'h'); if (b && b !== a) out.push(b); }
    return out;
  }

  /* --- Damerau-Levenshtein s prahem ------------------------------------ */
  function dist(a, b, cap) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > cap) return cap + 1;
    var prev2 = null, prev = [], cur, i, j, c, v, best;
    for (j = 0; j <= lb; j++) prev.push(j);
    for (i = 1; i <= la; i++) {
      cur = [i]; best = i;
      for (j = 1; j <= lb; j++) {
        c = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          v = Math.min(v, prev2[j - 2] + 1);
        }
        cur[j] = v;
        if (v < best) best = v;
      }
      if (best > cap) return cap + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }
  /* Na tříznakovém klíči je i práh 1 tak volný, že „led“ trefí „red“ — tam se
     vzdálenost nepočítá vůbec a rozhoduje jen přesná shoda nebo předpona. */
  function capFor(n) { return n < 4 ? 0 : (n <= 7 ? 1 : (n <= 10 ? 2 : 3)); }

  function canon(word) {
    var ks = folds(word), i, k, key, cap, best = null, bestd, d;
    if (!ks.length) return null;
    for (i = 0; i < ROWS.length; i++) {
      for (k = 0; k < ks.length; k++) if (ROWS[i][0] === ks[k]) return ROWS[i][1];
    }
    key = ks[0];
    for (k = 1; k < ks.length; k++) if (ks[k].length > key.length) key = ks[k];
    if (key.length >= 4) {
      for (i = 0; i < ROWS.length; i++) if (ROWS[i][0].indexOf(key) === 0) return ROWS[i][1];
    }
    cap = capFor(key.length);
    if (!cap) return null;
    bestd = cap + 1;
    for (i = 0; i < ROWS.length; i++) {
      if (ROWS[i][0].charAt(0) !== key.charAt(0)) continue;
      d = dist(key, ROWS[i][0], cap);
      if (d < bestd) { best = ROWS[i][1]; bestd = d; if (d === 0) break; }
    }
    return bestd <= cap ? best : null;
  }

  function correct(q) {
    if (!ROWS) return null;
    var w = String(q).split(/\s+/).filter(Boolean), out = [], changed = false, i, c;
    if (!w.length || w.length > 6) return null;
    for (i = 0; i < w.length; i++) {
      c = w[i].length >= 3 ? canon(w[i]) : null;
      if (c && c.toLowerCase() !== w[i].toLowerCase()) { out.push(c); changed = true; }
      else out.push(w[i]);
    }
    return changed ? out.join(' ') : null;
  }

  /* --- poznámka v panelu ----------------------------------------------- */
  var styled = false;
  function style() {
    if (styled) return; styled = true;
    var s = document.createElement('style');
    s.textContent = '.dls .dlfz{padding:10px clamp(20px,3vw,46px);font-size:13px;color:var(--mute,#98948C);' +
      'border-bottom:1px solid var(--line-2,#EEEDE9);background:var(--surface,#fff)}' +
      '.dls .dlfz b{color:var(--ink,#1A1916);font-weight:600}';
    document.head.appendChild(s);
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }
  function note(from, to) {
    setTimeout(function () {
      var box = document.querySelector('.dls'); if (!box) return;
      var old = box.querySelector('.dlfz'); if (old && old.parentNode) old.parentNode.removeChild(old);
      if (!to) return;
      var res = box.querySelector('.res'); if (!res || !res.parentNode) return;
      style();
      var el = document.createElement('div');
      el.className = 'dlfz';
      el.innerHTML = 'Na <b>„' + esc(from) + '“</b> nic nemáme — ukazujeme <b>„' + esc(to) + '“</b>.';
      res.parentNode.insertBefore(el, res);
      var all = box.querySelector('.all');
      if (all) {
        all.innerHTML = 'Všechny výsledky pro „' + esc(to) + '“ <span>→</span>';
        all.href = '/search?q=' + encodeURIComponent(to) + '&type=product';
      }
    }, 0);
  }

  /* --- obal nad fetch --------------------------------------------------- */
  function products(d) {
    return (d && d.resources && d.resources.results && d.resources.results.products) || [];
  }
  function qOf(u) {
    var m = String(u).match(/[?&]q=([^&]*)/);
    try { return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; } catch (e) { return ''; }
  }

  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    if (!ROWS || url.indexOf('/search/suggest') < 0) return origFetch(input, init);
    loadIndex();
    return origFetch(input, init).then(function (res) {
      if (!res || !res.ok) return res;
      return res.clone().json().then(function (d) {
        if (products(d).length) { note(null, null); return res; }
        var q = qOf(url), fixed = correct(q);
        if (!fixed) { note(null, null); return res; }
        var u2 = url.replace(/([?&]q=)[^&]*/, '$1' + encodeURIComponent(fixed));
        return origFetch(u2, init).then(function (r2) {
          if (!r2 || !r2.ok) return res;
          return r2.clone().json().then(function (d2) {
            if (!products(d2).length) { note(null, null); return res; }
            note(q, fixed);
            return new Response(JSON.stringify(d2), {
              status: 200, headers: { 'Content-Type': 'application/json' }
            });
          }).catch(function () { return res; });
        }).catch(function () { return res; });
      }).catch(function () { return res; });
    });
  };
})();
